<div class="events-container">
  <div class="events-header">
      <span class="events-title">{{ 'Home.events' | translate }}</span>
  </div>

  <div class="events-body">

      <div class="event-card" *ngFor="let event of eventsList">
          <div class="event-img-container">
            <img class="event-img" [src]="getSafeUrl(event.imageurl)" />
          </div>

          <h3 class="event-title">{{ event.title }}</h3>

          <p class="event-description">
            {{ event.description }}
          </p>

          <a *ngIf="event.link.href.length > 1"  class="events-learn-more" [href]="event.link.href" target="_blank">
            {{ event.link.text }}
          </a>

      </div>

  </div>
</div>
